import * as components from '../helpers/imports/PDPComponents'
import CMSComponents, { GetComponent } from './CMSComponents'

export { components, GetComponent }
export default CMSComponents
